import React from 'react'
import ReactDOM from 'react-dom'
import 'intersection-observer'
import 'whatwg-fetch'

import { router } from 'router'

import App from './app/App'

router.preSync()

ReactDOM.render( < App / > , document.getElementById('root'))


// WEBPACK FOOTER //
// ./src/index.js